import { useState } from "react";
import { Dropdown, DropdownSkeleton } from "carbon-components-react";
import { Label } from "../Label";

import useSWR from "swr";
import { URL, Fetcher as F } from "../../../api";

export const FoodVendor = ({
  id,
  className,
  style,
  field = {},
  data,
  filter = {},
  onChange,
}) => {
  const { key, required = false } = field;
  const { type = "number" } = field.schema;
  const title = "膳食廠商";
  const { center } = filter;

  const url = `${URL.foodVendor}?center=${center?.id ?? ""}`;
  const { data: list } = useSWR([url], F.withToken);
  const item = list !== undefined ? list.find((x) => x.id === data) : null;
  const [shouldValidate, setShouldValidate] = useState(false);
  const invalid = shouldValidate && required && data === undefined;

  return !list ? (
    <DropdownSkeleton id={id} className={className} style={style} />
  ) : (
    <Dropdown
      id={id}
      className={className}
      style={style}
      titleText={<Label required={required}>{title}</Label>}
      label="請選擇"
      items={list}
      itemToString={(item) => (item ? item.name : "")}
      selectedItem={item}
      invalid={invalid}
      invalidText="此為必選欄位"
      onFocus={() => setShouldValidate(false)}
      onBlur={() => setShouldValidate(true)}
      onChange={(e) => {
        let v = e.selectedItem.id;
        if (type === "number") {
          v = +v;
        }
        if (typeof onChange !== "function") return;
        onChange({ [key]: v });
      }}
    />
  );
};
